import * as Sentry from '@sentry/react';

import { IS_DISCORD_ACTIVITY } from '@/globals';
import { appVersion } from '@/utils/version';

export function initSentry() {
    if (IS_DISCORD_ACTIVITY) return;
    try {
        const release = process.env.PUBLIC_ENV !== 'dev' ? `arise-frontend@${appVersion}` : undefined;
        console.info(`Version ${appVersion}`);
        Sentry.init({
            dsn: process.env.PUBLIC_SENTRY_DSN,
            integrations: [],
            environment: process.env.PUBLIC_ENV,
            release: release,
            sampleRate: 1,
        });
        Sentry.setTag('instance', process.env.PUBLIC_INSTANCE);
    } catch (err) {
        console.error('Failed to initialize Sentry', err);
    }
}
